<form class="braintree-form" (ngSubmit)="submitForm($event)" id="braintree-payment-form" #form>
  <div class="braintree-form__fields">
    <!-- Card number spans the row, as in the design, with the trailing lock. -->
    <div class="bt-field bt-field--with-icon">
      <div class="bt-field__content">
        <label class="bt-field__label" for="braintree-card-number">{{
          'fgbcl.payment.braintree.card.number' | translate: { fgbdefault: 'Card Number' }
        }}</label>
        <!-- Braintree mounts its hosted-field iframe into this div, so it stays
             empty here and its interior is styled through the allowlist in the
             component's create() call, not from the scss. -->
        <div id="braintree-card-number" class="bt-field__input" [class.bt-field__input--invalid]="errors?.number"></div>
      </div>
      <span class="material-icons bt-field__icon" aria-hidden="true">lock</span>
    </div>
    @if (errors?.number) {
      <div class="bt-field__error" id="braintree-card-number-errors" role="alert">{{ errors.number }}</div>
    }

    <!-- Security code and expiry share a row, matching the design's paired fields. -->
    <div class="braintree-form__row">
      <div class="bt-field bt-field--with-icon" aria-describedby="braintree-cvv-help">
        <div class="bt-field__content">
          <label class="bt-field__label" for="braintree-card-cvv">{{
            'fgbcl.payment.braintree.card.cvv' | translate: { fgbdefault: 'Security Code' }
          }}</label>
          <div id="braintree-card-cvv" class="bt-field__input" [class.bt-field__input--invalid]="errors?.cvv"></div>
        </div>
        <!-- Help affordance, not a control: it opens nothing and submits
             nothing, so it is out of the tab order (tabindex="-1") and the
             tooltip is driven by hover and by :focus-visible for anyone who
             does reach it by other means. The text itself is exposed to
             assistive tech through aria-describedby on the wrapper, so
             skipping the tab stop costs nothing. -->
        <span
          class="bt-field__help"
          tabindex="-1"
          [attr.aria-label]="'fgbcl.payment.braintree.card.cvv.help' | translate: { fgbdefault: 'What is a security code?' }"
        >
          <span class="material-icons bt-field__icon" aria-hidden="true">help</span>
          <span class="bt-field__tooltip" id="braintree-cvv-help" role="tooltip">
            {{
              'fgbcl.payment.braintree.card.cvv.tooltip'
                | translate
                  : {
                      fgbdefault:
                        'The 3 or 4 digit security code on your card. Visa, Mastercard and Discover print it on the back; American Express prints it on the front.'
                    }
            }}
          </span>
        </span>
      </div>

      <div class="bt-field bt-field--with-icon" aria-describedby="braintree-expiry-help">
        <div class="bt-field__content">
          <label class="bt-field__label" for="braintree-card-expiry">{{
            'fgbcl.payment.braintree.card.expiry' | translate: { fgbdefault: 'Expiration Date (MM/YY)' }
          }}</label>
          <div id="braintree-card-expiry" class="bt-field__input" [class.bt-field__input--invalid]="errors?.expirationDate"></div>
        </div>
        <span
          class="bt-field__help"
          tabindex="-1"
          [attr.aria-label]="'fgbcl.payment.braintree.card.expiry.help' | translate: { fgbdefault: 'Where do I find this?' }"
        >
          <span class="material-icons bt-field__icon" aria-hidden="true">help</span>
          <!-- Aligned to its right edge: this field sits at the end of the row,
               so a centred tooltip would overflow the panel on narrow screens. -->
          <span class="bt-field__tooltip bt-field__tooltip--end" id="braintree-expiry-help" role="tooltip">
            {{
              'fgbcl.payment.braintree.card.expiry.tooltip'
                | translate
                  : {
                      fgbdefault:
                        'The expiry date printed on the front of your card, as month and year. Enter it as MM/YY, for example 04/28.'
                    }
            }}
          </span>
        </span>
      </div>
    </div>

    <div class="braintree-form__row-errors">
      @if (errors?.cvv) {
        <div class="bt-field__error" id="braintree-card-cvv-errors" role="alert">{{ errors.cvv }}</div>
      }
      @if (errors?.expirationDate) {
        <div class="bt-field__error" id="braintree-card-expiry-errors" role="alert">{{ errors.expirationDate }}</div>
      }
    </div>

    <div class="bt-field">
      <label class="bt-field__label" for="braintree-card-postal-code">{{
        'fgbcl.payment.braintree.card.postal.code' | translate: { fgbdefault: 'Zip Code' }
      }}</label>
      <div id="braintree-card-postal-code" class="bt-field__input" [class.bt-field__input--invalid]="errors?.postalCode"></div>
      @if (errors?.postalCode) {
        <div class="bt-field__error" id="braintree-card-postal-code-errors" role="alert">{{ errors.postalCode }}</div>
      }
    </div>
  </div>

  @if (hasError) {
    <div class="braintree-form__alert" role="alert">{{ 'fgbcl.payment.braintree.error.message' | translate }}</div>
  }

  <button
    class="braintree-form__submit"
    id="braintree-payment-request-button"
    type="submit"
    [disabled]="isLoading || !fieldsReady"
  >
    @if (isLoading) {
      <span class="braintree-form__loading">
        <fgbcl-loading size="small" />
      </span>
    }
    {{ 'fgbcl.payment.braintree.submit' | translate: { fgbdefault: 'Pay Now' } }}
  </button>
</form>
